/**
 * ListUtils
 *
 * From: 1.0.0
 * @packageDocumentation
 */

import { TypeUtils } from './UtilityTypes';

export const ListUtils = {
  /**
   *
   * @param array - リスト
   * @param attrGetter - 要素のゲッタ
   * @returns
   */
  distinct<T>(
    array: T[],
    attrGetter: FunctionType<T, unknown> = (element) => element
  ) {
    return array.filter(
      (element, index, ary) =>
        ary.findIndex((elem) => attrGetter(elem) === attrGetter(element)) ===
        index
    );
  },
  excludeNullOrUndefined<T>(array: Array<T | undefined> | undefined): T[] {
    return array === undefined
      ? []
      : (array?.filter(
          (element) => element !== undefined && element !== null
        ) as T[]);
  },
  isEmpty(array: unknown[] | undefined) {
    return array === undefined || array.length === 0;
  },
  isNotEmpty<T>(array: T[] | undefined): array is T[] {
    return !this.isEmpty(array);
  },
  sort:
    <T>(f: FunctionType<T, any>) =>
    (obja: T, objb: T) => {
      const a = f(obja);
      const b = f(objb);

      // a < b --> -1
      // a > b --> 1
      return TypeUtils.isNilStrict(a)
        ? TypeUtils.isNilStrict(b)
          ? 0
          : 1
        : TypeUtils.isNilStrict(b)
          ? -1
          : a === b
            ? 0
            : a < b
              ? -1
              : 1;
    },
};
